module.exports = __webpack_public_path__ + "img/tic-tac-toe.0c963a72.jpg";